import React from 'react';
import './TrustBadges.css';
import soc2Img from '../../assetsPng/Arp/soc2.png';
import isoImg from '../../assetsPng/Arp/iso.png';

const TrustBadges = ({ variant = 'horizontal', showText = true, size = 'medium' }) => {
  const iconSize = size === 'large' ? 24 : size === 'small' ? 16 : 20;
  const iconMargin = size === 'large' ? '12px' : '10px';
  
  return (
    <div className={`trust-badges trust-badges--${variant} trust-badges--${size}`}>
      {showText && (
        <div className="trust-badges__header">
          <span className="trust-badges__title">
            {/* <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: iconMargin, verticalAlign: 'middle'}}>
              <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="currentColor" fillOpacity="0.2"/>
              <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg> */}
            We are fully compliant with industry-leading security standards.
          </span>
        </div>
      )}
      
      <div className="trust-badges__container">
        {/* SOC 2 Badge */}
        <div className="trust-badge">
          <div className="trust-badge__icon">
            <img src={soc2Img} alt="SOC 2 Type II Compliant" className="trust-badge__image" />
          </div>
          <div className="trust-badge__content">
            <div className="trust-badge__title">SOC 2 Type II</div>
            <div className="trust-badge__subtitle">Certified</div>
          </div>
        </div>

        {/* ISO 27001 Badge */}
        <div className="trust-badge">
          <div className="trust-badge__icon">
            <img src={isoImg} alt="ISO 27001 Certified" className="trust-badge__image" />
          </div>
          <div className="trust-badge__content">
            <div className="trust-badge__title">ISO 27001</div>
            <div className="trust-badge__subtitle">Certified</div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TrustBadges;